import { UPDATE_SURVEY_PROPERTY, REMOVE_SURVEY_PROPERTY } from 'components/assignments/actions';

export default function(state = {}, action) {
  switch (action.type) {
  case UPDATE_SURVEY_PROPERTY: {
    let newState = state;
    const updatedTenantRepProperty = action.payload;

    if (newState.tenantRepProperties) {
      const tenantRepProperties = newState.tenantRepProperties.map((tenantRepProperty) => {
        return tenantRepProperty.id === updatedTenantRepProperty.id ? updatedTenantRepProperty : tenantRepProperty;
      });
      newState = { ...newState, tenantRepProperties: tenantRepProperties };
    }

    return newState;
  }
  case REMOVE_SURVEY_PROPERTY: {
    let newState = state;
    const propertyId = action.payload;

    if (newState.tenantRepProperties) {
      const tenantRepProperties =
        newState.tenantRepProperties.filter(tenantRepProperty => tenantRepProperty.id !== propertyId);
      newState = { ...newState, tenantRepProperties: tenantRepProperties };
    }

    return newState;
  }
  default:
    return state;
  }
}
